import { ScenarioResponseType } from "../../types";
import { isOperateMode } from "../../hooks/utils";
import { HudIcon, PlanIcon, MonitorIcon, ReportsIcon, FilesIcon } from './Svgs';

export const calculateProgressTime = (startTime: number, currentTime: number) => {
    const progressSeconds = Math.floor(currentTime - startTime);
    const hours = Math.floor(progressSeconds / 3600);
    const minutes = Math.floor((progressSeconds % 3600) / 60);
    const seconds = progressSeconds % 60;
    const formatNumber = (num: number): string => num.toString().padStart(2, '0');
    return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`;
}

export const calculateTimePercentage = (startTime: number, endTime: number, currentTime: number): number => {
    const totalDuration = endTime - startTime;
    const elapsedTime = currentTime - startTime;
    const percentage = Math.floor((elapsedTime / totalDuration) * 100);
    return Math.min(Math.max(percentage, 0), 100);
}

export const get_button_list = (tab_name: string | undefined, dashboard: string | undefined, scenarioOperation: string | undefined, scenario?: ScenarioResponseType | null) => {
    const isValidateSummary = (scenario?.scenarioDeploymentType ?? '').toUpperCase() === 'VALIDATE' && dashboard === 'summary'
    const isPlanTab = Boolean(tab_name?.includes('plan'))
    const isFilesTab = Boolean(tab_name?.includes('files'))
    const isReportsTab = tab_name === 'reports'
    const isMonitorTab = tab_name === 'monitor'
    const isValidateSummaryDefaultTab = isValidateSummary && !isPlanTab && !isFilesTab && !isMonitorTab && !isReportsTab

    const ButtonsList = [
        {
            label: 'HUD',
            show: !isValidateSummary,
            active: tab_name === 'hud',
            svg: <HudIcon />,
        },
        {
            label: 'Plan',
            show: isValidateSummary || ((dashboard !== 'quick-deploy' && scenarioOperation !== 'LEOP') ? true : false),
            active: Boolean(tab_name?.includes('plan')),
            svg: <PlanIcon />,
        },
        {
            label: 'Monitor',
            show: true,
            active: isValidateSummary ? isMonitorTab : tab_name === 'monitor',
            svg: <MonitorIcon />,
        },
        {
            label: 'Reports',
            show: (scenario?.scenarioDeploymentType ?? '').toUpperCase() === 'VALIDATE',
            active: isValidateSummary ? (isReportsTab || isValidateSummaryDefaultTab) : tab_name === 'reports',
            svg: <ReportsIcon />,
        },
        {
            label: 'Files',
            show: isValidateSummary || isOperateMode(dashboard, scenario ?? null),
            active: Boolean(tab_name?.includes('files')),
            svg: <FilesIcon />,
        },
    ]
    return ButtonsList
}
